<template>
  <div>
    <span v-html="message.message" />
    <br />
    <br />
    <span>
      {{ $t('chat.msg.check_failed.message_part_learn_how') }}
    </span>
    <div class="categories">
      <div
        class="item"
        :class="{
          'selected-item':
            message.selectedOption &&
            (article.id === message.selectedOption || article.id === message.selectedOption.id),
        }"
        @click="buildArticleSelectedEvent(article)"
      >
        <span class="item-text">{{ article.title }}</span>
        <span class="link-icon"> <FaAngleRight /> </span>
      </div>
    </div>

    <span v-if="articleAction" data-slot-after-article>{{ message.messageSlots.afterArticle }}</span>
    <div v-if="articleAction" class="categories">
      <div class="item" @click="buildActionEvent">
        <span class="item-text"> {{ articleAction.actionTitle }} </span>
        <span class="link-icon"> <FaAngleRight /> </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { SystemEvent } from '@/common/bot/enum';
import {
  ActionSelectedEvent,
  ArticleSystemOption,
  SystemArticleCheckFailureMessage,
  SystemOptionEvent,
} from '@/common/bot/types';
import FaAngleRight from '@/components/icons/FaAngleRight.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    FaAngleRight,
  },
})
export default class ArticleCheckFailureMessage extends Vue {
  @Prop({ default: () => ({}) }) readonly message!: SystemArticleCheckFailureMessage;

  get article() {
    return this.message.article;
  }

  get articleAction() {
    return this.message.article.action;
  }

  buildArticleSelectedEvent(article: ArticleSystemOption) {
    const event: SystemOptionEvent = {
      type: SystemEvent.LIST_OPTION_SELECTED,
      message: this.message,
      payload: {
        selected: { ...article },
      },
    };

    this.$emit('send:event', event);
  }

  buildActionEvent() {
    if (!this.articleAction) return;
    const event: ActionSelectedEvent = {
      type: SystemEvent.ACTION_SELECTED,
      message: this.message,
      payload: { action: this.articleAction },
    };
    this.$emit('send:event', event);
  }
}
</script>

<style scoped lang="scss">
@import './ActionButtonCommon.scss';
</style>
